export function maximumDateHelper(limit: number): Date {
    const today = new Date();
    const currentYear = today.getFullYear();
    const maxDate = new Date(
        currentYear + limit, // Change addition to subtraction
        today.getMonth(),
        today.getDate()
    );
    return maxDate;
}
